export const mockCopy = [
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc maximus gravida augue nec fermentum.',
  'Maximus gravida augue nec fermentum. In tincidunt ex eu mi tincidunt.',
  'Phasellus commodo, diam ut rhoncus auctor, dui ipsum viverra felis, eu varius orci ipsum ac elit.',
  'Nunc maximus gravida augue nec fermentum. In tincidunt ex eu mi tincidunt.',
  'In tincidunt ex eu mi tincidunt, a lobortis nunc tempor.'
];
